import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";
const FeeTyoe = "/api/business/feeType";
const CheckDuplicateCpn = "/api/business/check-duplicate-company";
const DoctypeListCreate = "/api/business/doc-type-list";
const DoctypeList = "/api/business/doc-type-for-eform-list";
//danh sách
const getListEform = "/api/business/eform-list";
export default class FromElectronicService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllCompanies(params?: any, query?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/company-for-eform?page=${params.page}&size=${params.size}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getBusinessCpn(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/company-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public AllFeetype(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(FeeTyoe, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // Danh sách biểu mẫu
  public getListEform(querySearch?: any, params?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(getListEform + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(params), querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getProvince(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/province`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getDistrict(code: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/district-code` + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(code))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllDistrict(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/district-code`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // Update
  public getEditDistrictById(query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`/api/business/tax-department`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  //

  public getDistrictById(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/tax-department?id=${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public removeDistrict(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`/api/business/tax-department/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllDepartment(queryForm: any, cancelToken): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/all-tax-department`, queryForm, { cancelToken: cancelToken.token })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAddDepartment(queryForm: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/tax-department`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // chi tiết biểu mẫu
  public getDetail(id?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/eform?id=${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  //delete e-form
  public deleteElform(id?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/tax-department/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // edit el-form
  public EditElform(queryForm?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/edit-eform`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
